import { ProviderWithLogo } from "../ProviderWithLogo";

import { ProviderDropdownProps } from "./types";
import { mapProviderToDisplayName } from "./utils";

import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";

export const ProviderDropdown = ({
  selectedProvider,
  handleSelectProvider,
  providers,
}: ProviderDropdownProps) => (
  <Select value={selectedProvider} onValueChange={handleSelectProvider}>
    <SelectTrigger className="w-full justify-between bg-white">
      {mapProviderToDisplayName(selectedProvider) || (
        <span className="text-gray-400">Select provider...</span>
      )}
    </SelectTrigger>
    <SelectContent>
      {providers?.map(provider => (
        <SelectItem key={provider.name} value={provider.name}>
          <ProviderWithLogo provider={provider.name} />
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
